<template>
    <div id="invoice_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="invoiceHeader" v-if="$route.params.id > 0">Update Customer Invoice</span>
                    <span class="page-title" id="invoiceHeader" v-else>Add Customer Invoice</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackInvoiceList"  >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content wo-invoice-crude list-view">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="InvoiceForm">
                                <div class="form-row section-divider">
                                    <div class="col-md-4">
                                        <div class="row form-group">
                                            <label class="col">Unit :</label>
                                            <span class="col">{{unit}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">VIN :</label>
                                            <span class="col">{{vinNumber}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="row form-group">
                                            <label class="col">Date In :</label>
                                            <span class="col">{{dateIn}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Date Out :</label>
                                            <span class="col">{{dateOut}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="row form-group">
                                            <label class="col">Facility :</label>
                                            <span class="col">{{facility}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Meter :</label>
                                            <span class="col">{{meter}} MLS</span>
                                        </div>
                                    </div>
                                </div>     
                                <div class="form-row row-cols-md-4 row-cols-1 mt-4">              
                                    <div v-if="$route.params.id > 0" class="col form-group mt-3">
                                        <label class="control-label" for="invoice_number">Invoice #: </label>
                                        <span class="label font-semibold">{{invoice_number}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>                                                
                                        <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" @input="onCustomerChange(customer_id)" placeholder="Select Customer" class='custom-ci-auto-search close-remove' v-on:change="termSelect()">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Customer Email:</label>
                                        <input type="text" class="form-control" v-model="emails" id="emails" placeholder="Enter Emails" name="emails">
                                        <div class="field-error">{{emails_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="invoice_type">Term:</label>
                                        <v-select v-model="term" name="term" placeholder="Select Term" label="text" class='close-remove' :options="termsArr" @input="onTermChange($event)">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Invoice Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="invoice_date" name="invoice_date" v-model="invoice_date" :config="optionsDate" aria-describedby="basic-addon3" @dp-change="onInvDateChange"></date-picker>
                                            <label for="invoice_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{invoice_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Due Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="due_date" name="due_date" v-model="due_date" :config="optionsDueDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="due_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{due_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="invoice_type">Invoice Type:</label>
                                        <v-select v-model="invoice_type" name="invoice_type" placeholder="Select Invoice Type" label="text" class='close-remove' :options="invoiceTypesArr" :disabled="disableField">
                                        </v-select>
                                        <div class="field-error">{{invoice_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="state">Reason:</label>
                                        <v-select v-model="reason_id" name="reason_id" placeholder="Select reason." label="text" :options="reasonArr" :disabled="disableAll">
                                        </v-select>
                                        <!-- <div class="field-error">{{reason_error_msg}}</div> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="customer_purchase_order">PO:</label>                                                
                                        <input type="text" class="form-control" v-model="customer_purchase_order" id="customer_purchase_order" placeholder="Enter PO#" name="customer_purchase_order">
                                        <!-- <v-select v-model="customer_purchase_order" name="customer_purchase_order" id="customer_purchase_order" label="text" :filterable="false" :options="customerPurchaseOrderArr" @search="onSearchPO" placeholder="Select PO" class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search PO...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template> -->
                                        </v-select>
                                    </div>
                                </div>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="table-responsive-sm mt-4">
                                    <table aria-describedby="table" class="table table-sm">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col">Type</th>
                                                <th scope="col">VMRS / Part No.</th>
                                                <th scope="col" class="require">Labor / Part Description</th>
                                                <th scope="col" class="text-right">Hours</th>
                                                <th scope="col" class="require text-right">Quantity</th>
                                                <th scope="col" class="require text-right">Unit Price</th>
                                                <th scope="col" class="text-right">Amount</th>
                                                <th scope="col" class="text-center"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <template  v-if="row.wo_item_id > 0">
                                                        <v-select v-model="row.item_type" disabled name="item_type" class="close-remove" placeholder="Select Type." label="text" :options="invoiceItemTypesArr" @input="onItemTypeSelect($event,index)">
                                                        </v-select>
                                                    </template>
                                                    <template v-else>
                                                        <v-select v-model="row.item_type" name="item_type" class="close-remove" placeholder="Select Type." label="text" :options="invoiceItemTypesArr" @input="onItemTypeSelect($event,index)">
                                                        </v-select>
                                                    </template>
                                                    <div class="field-error">{{row.item_type_error_msg}}</div>
                                                </td>    
                                                <td>                                                                
                                                    <template v-if="row.type == 'labor' || row.type == 'sublet_amount' || row.type == 'sublet_part' || row.type == 'sublet_labor' || row.type == 'ADMIN' || row.type == 'ENVIR' || row.type == 'FET' || row.type == 'FRT' || row.type == 'RSTOCK'  || (row.is_charge != undefined && row.is_charge == 1)">
                                                        <input type="text" disabled placeholder="VMRS System / Part Number" v-model="row.vmrs_system_part_number"  name="vmrs_system_part_number" id="vmrs_system_part_number" class="vgt-input">
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" placeholder="VMRS System / Part Number" v-model="row.vmrs_system_part_number"  name="vmrs_system_part_number" id="vmrs_system_part_number" class="vgt-input">
                                                        <div class="field-error">{{row.vmrs_system_part_error_msg}}</div>
                                                    </template>    
                                                </td>
                                                <td>
                                                    <input type="text" v-model="row.description" name="description" placeholder="Description"
                                                    class="vgt-input">
                                                    <div class="field-error">{{row.desc_error_msg}}</div>
                                                </td>
                                                <td class="text-right">
                                                    <template v-if="row.type == 'labor'">
                                                        <input type="text" placeholder="Hours" v-model="row.hours"  name="hours" id="hours" class="vgt-input text-right" style=" width: 100% !important;" v-on:keyup="calculateTotal($event,index)" @keypress="isNumberCheck($event)">
                                                        <div class="field-error">{{row.hour_error_msg}}</div>
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" disabled placeholder="Hours" v-model="row.hours"  name="hours" id="hours" class="vgt-input text-right" style=" width: 100% !important; " v-on:keyup="calculateLaborAmount($event,index)" @keypress="isNumberCheck($event)">
                                                    </template>    
                                                </td>
                                                <td class="text-right">
                                                    <template v-if="row.type == 'labor' || row.type == 'sublet_amount' || row.type == 'sublet_part' || row.type == 'sublet_labor'|| row.type == 'ADMIN' || row.type == 'ENVIR' || row.type == 'FET' || row.type == 'FRT' || row.type == 'RSTOCK' || (row.is_charge != undefined && row.is_charge == 1)">
                                                        <input type="text" disabled placeholder="Quantity" v-model="row.quantity"  name="quantity" v-on:keyup="calculatePartAmount($event,index)" id="quantity" class="vgt-input text-right" style=" width: 100% !important;" @keypress="isNumberCheck($event)">
                                                        <div class="field-error">{{row.quantity_error_msg}}</div>
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" placeholder="Quantity" v-model="row.quantity"  name="quantity" v-on:keyup="calculateTotal($event,index)" id="quantity" class="vgt-input text-right" style=" width: 100% !important; " @keypress="isNumberCheck($event)">
                                                        <div class="field-error">{{row.quantity_error_msg}}</div>
                                                    </template>    
                                                </td>
                                                <td class="text-right">
                                                    <!-- <template v-if="row.type == 'sublet_amount'|| row.type == 'sublet_part' || row.type == 'sublet_labor' || row.type == 'ADMIN' || row.type == 'ENVIR' || row.type == 'FET' || row.type == 'FRT' || row.type == 'RSTOCK'"> -->
                                                    <template v-if="row.type == 'sublet_amount' || row.type == 'ADMIN' || row.type == 'ENVIR' || row.type == 'FET' || row.type == 'FRT' || row.type == 'RSTOCK' || (row.is_charge != undefined && row.is_charge == 1)">    
                                                        <input type="text" disabled placeholder="Unit Price" v-model="row.unit_price" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event)" name="unit_price" class="vgt-input text-right" style=" width: 100% !important; ">
                                                        <div class="field-error">{{row.unit_price_error_msg}}</div>
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" placeholder="Unit Price" v-model="row.unit_price" v-on:keyup="calculateTotal($event,index)" @keypress="isNumberCheck($event)" name="unit_price" class="vgt-input text-right" style=" width: 100% !important; ">
                                                        <div class="field-error">{{row.unit_price_error_msg}}</div>
                                                    </template>    
                                                </td>
                                                <td class="text-right">
                                                    <!-- <template v-if="row.type == 'sublet_amount'|| row.type == 'sublet_part' || row.type == 'sublet_labor' || row.type == 'charges' || row.type == 'ADMIN' || row.type == 'ENVIR' || row.type == 'FET' || row.type == 'FRT' || row.type == 'RSTOCK'"> -->
                                                    <template v-if="row.type == 'sublet_amount' || row.type == 'charges' || row.type == 'ADMIN' || row.type == 'ENVIR' || row.type == 'FET' || row.type == 'FRT' || row.type == 'RSTOCK' || (row.is_charge != undefined && row.is_charge == 1)">    
                                                        <input type="text" placeholder="Amount"  v-model="row.amount" id="amount" name="amount" class="vgt-input text-right" v-on:keyup="calculateTotal($event,index)" @keypress="isNumberCheck($event)">
                                                        <div class="field-error">{{row.amount_error_msg}}</div>
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" disabled placeholder="Amount"  v-model="row.amount" id="amount" name="amount" class="vgt-input text-right">
                                                    </template>    
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="rows.length != 1">
                                                        <a href="javascript:void(0);" v-on:click="removeItem($event,index);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>    
                                        </tbody>    
                                    </table>    
                                </div>    
                                <div class="btn-groups mb-4">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>                                        
                                <template v-if="showTotalSummary">
                                    <div class="order-summary mt-4">
                                        <div class="row">
                                            <div class="col-md-6 offset-md-6">
                                                <div class="bg-white radius-5 p-3">
                                                    <label> SUMMARY </label>
                                                    <table aria-describedby="table" class="table table-sm table-bordered table-striped">
                                                        <tr class="table-secondary">
                                                            <td>Total Labor:</td>
                                                            <td class="text-right">{{currencyFormat(total_labor)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Parts:</td>
                                                            <td class="text-right">{{currencyFormat(total_parts)}}</td>
                                                        </tr>
                                                        <tr class="table-secondary">
                                                            <td>Total Sublet:</td>
                                                            <td class="order-total text-right"> {{currencyFormat(total_sublet)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td> Other Charges: </td>
                                                            <td class="text-right"> {{currencyFormat(other_charges)}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td> Shop Supplies: </td>
                                                            <td class="text-right"> {{currencyFormat(shop_supplies)}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td> Total Before Tax: </td>
                                                            <td class="text-right"> {{currencyFormat(sub_total)}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td> SALES TAX: </td>
                                                            <td class="text-right"> {{currencyFormat(sales_tax)}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td> Total Taxes: </td>
                                                            <td class="text-right"> {{currencyFormat(total_tax)}} </td>
                                                        </tr>
                                                        <tr class="total-workorder">
                                                            <td> Total Due This Invoice: </td>
                                                            <td class="order-total text-right"> {{currencyFormat(total)}} </td>
                                                        </tr>    
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>        
                                </template>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>    
                                <div class="btn-groups">
                                    <button type="submit" id="CreateInvoiceBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateInvoice" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateInvoiceBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateInvoice" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelInvoiceBtn" class="btn btn-tertiary" v-on:click.prevent="BackInvoiceList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>        
                            </form>            
                        </section>    
                    </div>        
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>        
    </div>    
    
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import { isVariableDeclarator, isThisExpression, isSwitchStatement } from 'babel-types';
import moment from 'moment';
export default {
    name: "WorkOrderInvoiceCreate",
    metaInfo() {
        return {
            title: (this.$route.query.work_order_id != undefined)? "Create Customer Invoice | " +process.env.COPYRIGHT_NAME : "Update Customer Invoice | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        customerArr:[],
        customer_id:null,
        customer_error_msg:"",
        invoice_number:"",
        // invoice_number_error_msg:"",
        invoice_date:"",
        invoice_date_error_msg:"",
        due_date:"",
        due_date_error_msg:"",
        customer_purchase_order:null,
        customerPurchaseOrderArr:[],
        invoice_type:null,
        invoice_type_error_msg:"",
        invoiceTypesArr:[],
        rows: [],
        sub_total:0,
        tax:0,
        total_tax:0,
        total:0,
        taxesArr:[],
        term:"",
        termsArr:[],
        work_order_id:"",
        unit:"",
        vinNumber:"",
        meter:"",
        facility:"",
        dateIn:"",
        dateOut:"",
        total_labor:0,
        total_parts:0,
        total_sublet:0,
        total_environmental:0,
        other_charges:0,
        shop_supplies:0,
        sales_tax:0,
        common_error_msg:"",
        invoiceItemTypesArr:[],
        location_id:"",
        disableField:false,
        showTotalSummary:false,
        emails_error_msg:'',
        emails:'',
        accountsArr:[],
        city_sales_tax:0,
        customerPriceBookArr:[],
        defaultPriceBookArr:[],
        reasonArr:[],
        reason_id : "",
        reason_error_msg : "",
        vehicle_id:'',
        customerCall:false,
        termCall:false,
        invDateCall:false,
        isCredit:false,
    }),
    watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_invoice') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        sub_total:function(){
            var self = this;
          
            self.total= self.sub_total + self.total_tax;
            
        },
        /*tax:function(){
            var self = this;
            if(self.tax == ""){                
                self.total_tax = 0;
            }else{
                self.total_tax = (self.sub_total * self.tax)/100;
            }    
        },*/
        total_tax:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;
            // alert(self.total);
        },
        //to populate due date and term
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['invoiceTypes','taxes','terms','reason']);
        
        var path = window.location.pathname;
        var segments = path.split("/");
        // if (segments[3]) {
        //     self.loadInvoice();            
        // }else{
            // self.rows.push({
            //     invoice_item_id:0,          
            //     description:"",
            //     desc_error_msg:"",           
            //     quantity:"",
            //     quantity_error_msg:"",            
            //     unit_price:"",
            //     unit_price_error_msg:"",            
            //     amount:0,
            //     amount_error_msg:"",
            //     // tax_id:"",
            //     // tax_amount:0,
            //     total:0            
            // }); 
        // }
        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            self.loadInvoice();
        }else
        if (self.$route.query.work_order_id != undefined) {
            self.work_order_id = self.$route.query.work_order_id;    
            console.log(self.work_order_id);
            self.loadWorkOrderDataForInvoice();
        }else{
            console.log(segments[4]);
            self.loadInvoice();
        }
        var todayDate = self.getTodayDate();
        self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
        self.getWoLineChargeTypes();
        if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
            self.isCredit = true;
        }
    },
    methods: {
        onCustomerChange: function (newVal) {
            var self = this;
            self.getPriceBookValue();
            //prevent watch call for first time in case of update and on create invoice from wo view
            // if ( (self.$route.params.id > 0 && !self.customerCall) || ( self.$route.params.work_order_id != "" )) {
            //     return;
            // } else {  
                
            self.emails = newVal.email;
            if (self.customer_id != null && newVal.term != "" ) {

                var date = '';
                if(newVal.term_period == 'month') {
                    date = moment(self.invoice_date, "MM/DD/YYYY")
                            .add(newVal.term_term,'month') //replace 2 with number of days you want to add

                }else{

                    date = moment(self.invoice_date, "MM/DD/YYYY")
                            .add(newVal.term_term,'days')
                }
                self.due_date = date;
            }
            // }
        },
        BackInvoiceList() {
            var self = this;
            if(self.$route.params.from != undefined && self.$route.params.from == 'woInvList'){
                self.$router.push("/workorder/invoice/list");
            }else{
                self.redirectPageRoleWise("/invoice/list","/workorder/invoice/list","wo-invoice");
            }
        },
        onSearchCustomer(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer', 'wo-email');
            }
        },
        onSearchPO(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer_purchase_order', '');
            }    
        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                if (self.location_id != null && self.location_id > 0){
                    
                    self.searchField(loading, search, 'accounts', self.location_id);

                }else{
                    
                    self.searchField(loading, search, 'accounts', '');

                }
            }
        },
        getPriceBookValue:function(){
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/price-book/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    customer_id:self.customer_id.value,
                    location_id:self.location_id,
                    vehicle_id:self.vehicle_id
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.customerPriceBookArr = data.content.customer;
                        self.defaultPriceBookArr = data.content.default;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-number');
                }
            });
        },
        arrayColumn(array, type) {

            if (array.length){
                for(var i =0;i<array.length;i++){
                    if (array[i].cost_type == type){
                        return array[i];
                    }
                }
            }
        },
        addRow: function () {
            var self = this;
            var index=self.rows.length-1;
            var error = false;

            if (self.rows.length < 1) {
                 
                self.rows.push({
                    wo_labor_id:null,
                    wo_component_id:null,
                    wo_item_id:null,
                    work_order_id:self.work_order_id,
                    service_task_id:null,
                    service_task_name:"",
                    service_task_code:"",
                    component_id:null,
                    component_name:"",
                    component_code:"",
                    hours:"",
                    quantity:"",
                    unit_price:"",
                    amount:0,
                    actual_amount:0,
                    description:"",
                    vmrs_system_part_number:"",
                    type:"",
                    invoice_item_id:0,
                    wo_invoice_mapper_id:0,
                    is_sublet:0,
                    item_type:{
                        text:"",
                        value:""
                    },
                    vmrs_system_part_error_msg:"",
                    desc_error_msg:"",
                    hour_error_msg:"",
                    quantity_error_msg:"",            
                    unit_price_error_msg:"",            
                    amount_error_msg:"",
                    item_type_error_msg:"",
                    is_charge:0
                    // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                    //     value: data.content[i].tax_id,
                    //     text: data.content[i].tax_name,
                    //     percentage:data.content[i].tax_percentage,
                    // } : "",
                    // tax_amount:data.content[i].tax_amount,
                    // total:0      
                });

            }else{
               
                 console.log(self.rows[index]);
                self.rows[index].desc_error_msg = "";
                self.rows[index].quantity_error_msg = "";
                self.rows[index].unit_price_error_msg = "";
                self.rows[index].amount_error_msg = "";
                self.rows[index].vmrs_system_part_error_msg = "";
                self.rows[index].hour_error_msg = "";
                self.rows[index].item_type_error_msg = "";

                // if( self.rows[index].item_type == null || self.rows[index].item_type.value == "") {
                //     self.rows[index].item_type_error_msg = "Type Required.";
                //     error = true;                
                // }

                // if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                //     self.rows[index].desc_error_msg = "Description Required.";
                //     error = true;
                // }

                // if ( self.rows[index].hours == null || String(self.rows[index].hours) == "") {
                //     self.rows[index].hour_error_msg = "Hours Required.";
                //     error = true;
                // }

                // if ( self.rows[index].quantity == null || String(self.rows[index].quantity) == "" ) {
                //     self.rows[index].quantity_error_msg = "Quantity Required.";
                //     error = true;
                // }

                // if ( self.rows[index].unit_price == null || String(self.rows[index].unit_price) == "") {
                //     self.rows[index].unit_price_error_msg = "Unit Price Required.";
                //     error = true;
                // }

                // if (self.rows[index].amount == null || String(self.rows[index].amount) == "") {
                //     self.rows[index].amount_error_msg = "Amount Required.";
                //     error = true;
                // }

                // if (String(self.rows[index].hours) != "" && self.rows[index].hours == 0) {
                //     self.rows[index].hour_error_msg = "Hours cannot be 0.";
                //     error = true;    
                // }

                // if (String(self.rows[index].unit_price) != "" && self.rows[index].unit_price == 0) {
                //     self.rows[index].unit_price_error_msg = "Unit Price cannot be 0.";
                //     error = true;    
                // }

                // if (String(self.rows[index].quantity) != "" && self.rows[index].quantity == 0) {
                //     self.rows[index].quantity_error_msg = "Quantity cannot be 0.";
                //     error = true;    
                // }

                // if (String(self.rows[index].amount) != "" && self.rows[index].amount == 0) {
                //     self.rows[index].amount_error_msg = "Amount cannot be 0.";
                //     error = true;    
                // }

                if( self.rows[index].item_type != null && self.rows[index].item_type.value != "") {

                    if( self.rows[index].item_type.value == "labor" ) {
                        
                        if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                            self.rows[index].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[index].hours == null || String(self.rows[index].hours) == "") {
                            self.rows[index].hour_error_msg = "Hours Required.";
                            error = true;
                        }

                        if ( self.rows[index].unit_price == null || String(self.rows[index].unit_price) == "") {
                            self.rows[index].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                        }

                        if (String(self.rows[index].hours) != "" && self.rows[index].hours == 0) {
                            self.rows[index].hour_error_msg = "Hours cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[index].hours == "-") {
                            self.rows[index].hour_error_msg = "Hours cannot be '-'";
                            error = true;
                        }
                        if (String(self.rows[index].unit_price) != "" && self.rows[index].unit_price == 0) {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[index].unit_price == "-") {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be '-'";
                            error = true;
                        }

                    }else if( self.rows[index].item_type.value == "part" ) {
                        
                        if ( self.rows[index].vmrs_system_part_number == null || self.rows[index].vmrs_system_part_number == "" ) {
                            self.rows[index].vmrs_system_part_error_msg = "Part Number Required.";
                            error = true;
                        
                        }

                        if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                            self.rows[index].desc_error_msg = "Description Required.";
                            error = true;
                               
                        }

                        if ( self.rows[index].quantity == null || String(self.rows[index].quantity) == "" ) {
                            self.rows[index].quantity_error_msg = "Quantity Required.";
                            error = true;
                               
                        }

                        if ( self.rows[index].unit_price == null || String(self.rows[index].unit_price) == "") {
                            self.rows[index].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                             
                        }

                        if (String(self.rows[index].quantity) != "" && self.rows[index].quantity == 0) {
                            self.rows[index].quantity_error_msg = "Quantity cannot be 0.";
                            error = true;   
                            
                        }

                        if (String(self.rows[index].unit_price) != "" && self.rows[index].unit_price == 0) {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                             
                        }
                        if (self.rows[index].unit_price == "-") {
                            self.rows[index].quantity_error_msg = "Quantity cannot be '-'";
                            error = true;
                        }
                        if (self.rows[index].quantity == "-") {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be '-'";
                            error = true;
                        }

                    }else if( self.rows[index].item_type.value == "sublet_amount" ) {                    
                        
                        if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                            self.rows[index].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if (self.rows[index].amount == null || String(self.rows[index].amount) == "") {
                            self.rows[index].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[index].amount) != "" && self.rows[index].amount == 0) {
                            self.rows[index].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[index].amount == "-") {
                            self.rows[index].amount_error_msg = "Amount cannot be '-'";
                            error = true;
                        }

                    }else if( self.rows[index].item_type.value == "sublet_labor" ) {
                    
                        if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                            self.rows[index].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[index].hours == null || String(self.rows[index].hours) == "") {
                            self.rows[index].hour_error_msg = "Hours Required.";
                            error = true;
                        }

                        if ( self.rows[index].unit_price == null || String(self.rows[index].unit_price) == "") {
                            self.rows[index].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                        }

                        if (String(self.rows[index].hours) != "" && self.rows[index].hours == 0) {
                            self.rows[index].hour_error_msg = "Hours cannot be 0.";
                            error = true;    
                        }

                        if (String(self.rows[index].unit_price) != "" && self.rows[index].unit_price == 0) {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                             
                        }

                        if (self.rows[index].amount == null || String(self.rows[index].amount) == "" ) {
                            self.rows[index].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[index].amount) != "" && self.rows[index].amount == 0) {
                            self.rows[index].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[index].hours == "-") {
                            self.rows[index].hour_error_msg = "Hours cannot be '-'";
                            error = true;
                        }
                        if (self.rows[index].unit_price == "-") {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be '-'";
                            error = true;
                        }
                        if (self.rows[index].amount == "-") {
                            self.rows[index].amount_error_msg = "Amount cannot be '-'";
                            error = true;
                        }
                    }else if( self.rows[index].item_type.value == "sublet_part" ) {
                        
                        if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                            self.rows[index].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[index].unit_price == null || String(self.rows[index].unit_price) == "") {
                            self.rows[index].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                             
                        }

                        if (String(self.rows[index].quantity) != "" && self.rows[index].quantity == 0) {
                            self.rows[index].quantity_error_msg = "Quantity cannot be 0.";
                            error = true;   
                            
                        }

                        if (String(self.rows[index].unit_price) != "" && self.rows[index].unit_price == 0) {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                             
                        }

                        if (self.rows[index].amount == null || String(self.rows[index].amount) == "") {
                            self.rows[index].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[index].amount) != "" && self.rows[index].amount == 0) {
                            self.rows[index].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[index].quantity == "-") {
                            self.rows[index].quantity_error_msg = "Quantity cannot be '-'";
                            error = true;
                        }
                        if (self.rows[index].unit_price == "-") {
                            self.rows[index].unit_price_error_msg = "Unit Price cannot be '-'";
                            error = true;
                        }
                        if (self.rows[index].amount == "-") {
                            self.rows[index].amount_error_msg = "Amount cannot be '-'";
                            error = true;
                        }

                    }
                  
                    if(!error) {
                        self.rows.push({
                            wo_labor_id:null,
                            wo_component_id:null,
                            wo_item_id:null,
                            work_order_id:self.work_order_id,
                            service_task_id:null,
                            service_task_name:"",
                            service_task_code:"",
                            component_id:null,
                            component_name:"",
                            component_code:"",
                            hours:"",
                            quantity:"",
                            unit_price:"",
                            amount:0,
                            actual_amount:0,
                            description:"",
                            vmrs_system_part_number:"",
                            type:"",
                            invoice_item_id:0,
                            wo_invoice_mapper_id:0,
                            is_sublet:0,
                            item_type:{
                                text:"",
                                value:""
                            },
                            vmrs_system_part_error_msg:"",
                            desc_error_msg:"",
                            hour_error_msg:"",
                            quantity_error_msg:"",            
                            unit_price_error_msg:"",            
                            amount_error_msg:"",
                            item_type_error_msg:"",
                            is_charge:0
                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                            //     value: data.content[i].tax_id,
                            //     text: data.content[i].tax_name,
                            //     percentage:data.content[i].tax_percentage,
                            // } : "",
                            // tax_amount:data.content[i].tax_amount,
                            // total:0      
                        });
                    }
                }

            }                                                                    
               
            // }
            if ( self.rows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        getWoLineChargeTypes(){
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/wo/charge/list",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                        if(data.status=='success'){
                            self.invoiceItemTypesArr=data.content;
                        }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-code')
                }
            });
        },
        calculateAmount($event, index) {

            var self = this;
            if(self.rows[index].quantity==0 || self.rows[index].unit_price==0 || self.rows[index].quantity == null ||self.rows[index].unit_price == null)
            {

            }
            self.calculateTaxSubTotal();

        },
        calculateLaborAmount($event,index){
            var self = this;
            var totalLaborAmount = 0;
            for(var i=0;i<self.rows.length;i++)
            {
                if(self.rows[i].type == "labor"){
                    self.rows[i].amount=self.rows[i].hours * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalLaborAmount += self.rows[i].amount; 
                }
            }

            self.total_labor = totalLaborAmount;

            self.sub_total = self.total_labor + self.total_parts;

        },
        calculatePartAmount($event,index){
            var self = this;
            var totalPartAmount = 0;
            for(var i=0;i<self.rows.length;i++)
            {
                if(self.rows[i].type == "part"){
                    self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalPartAmount += self.rows[i].amount; 
                }
            }

            self.total_parts = totalPartAmount;

            self.sales_tax = parseFloat((self.total_parts / 100) * self.city_sales_tax); //sales tax calculation
            self.total_tax = self.sales_tax;

            self.sub_total = self.total_labor + self.total_parts;

        },
        calculateSubletAmount($event,index){
            var self = this;
            var totalSubletAmount = 0;
            for(var i=0;i<self.rows.length;i++){
                if(self.rows[i].type == "sublet" && self.rows[i].amount != ""){
                    // self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalSubletAmount += self.rows[i].amount;
                }    
            }

            self.total_sublet = totalSubletAmount;

            self.sub_total = self.total_sublet;
        },
        calculateTotal($event,index){
          
            var self = this;
            var totalLaborAmount = 0;
            var totalPartAmount = 0;
            var totalSubletAmount = 0;
            var salesTaxAmount = 0;
            var subletAmount = 0;
            var subletLaborAmount = 0;
            var subletPartAmount = 0;
            var totalBeforeTax = 0;
            var salesTax = 0;
            var supplySalesTax = 0;
            var totalTaxes = 0;
            var totalAmount = 0;
            var salesTaxPercent = self.city_sales_tax;
            var otherCharges = 0;
            var Supplies = 0;

            for (var i=0;i<self.rows.length;i++) {
                console.log('inrows');
                  console.log(self.rows[i]);  
                var amount = 0;
                if(self.rows[i].type == "labor"){
                    if(self.rows[i].hours.includes(',')){
                        self.rows[i].hours = self.rows[i].hours.replace(',','');
                    }
                    if(self.rows[i].unit_price.includes(',')){
                        self.rows[i].unit_price = self.rows[i].unit_price.replace(',','');
                    }

                    self.rows[i].amount=self.rows[i].hours * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalLaborAmount += self.rows[i].amount;
                    self.rows[i].amount = self.rows[i].amount.toFixed(2); 
                }else if (self.rows[i].type == "part"){
                     if(self.rows[i].quantity.includes(',')){
                        self.rows[i].quantity = self.rows[i].quantity.replace(',','');
                    }
                    if(self.rows[i].unit_price.includes(',')){
                        self.rows[i].unit_price = self.rows[i].unit_price.replace(',','');
                    }

                    self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalPartAmount += self.rows[i].amount;
                    self.rows[i].amount = self.rows[i].amount.toFixed(2);
                }else if (self.rows[i].type == "sublet_amount" && self.rows[i].amount != ""){  
                    if(self.rows[i].amount.includes(',')){
                        amount = self.rows[i].amount.replace(',','');
                    }else{
                        amount = self.rows[i].amount;
                    }                         
                    subletAmount += parseFloat(amount);
                }else if (self.rows[i].type == "sublet_labor"){   
                    /*if(self.rows[i].amount.includes(',')){
                        amount = self.rows[i].amount.replace(',','');
                    }else{
                        amount = self.rows[i].amount;
                    }                         
                    subletLaborAmount += parseFloat(amount);*/
                    if(self.rows[i].hours.includes(',')){
                        self.rows[i].hours = self.rows[i].hours.replace(',','');
                    }
                    if(self.rows[i].unit_price.includes(',')){
                        self.rows[i].unit_price = self.rows[i].unit_price.replace(',','');
                    }

                    self.rows[i].amount=self.rows[i].hours * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    subletLaborAmount += self.rows[i].amount; 
                    self.rows[i].amount = self.rows[i].amount.toFixed(2);
                }else if (self.rows[i].type == "sublet_part"){     
                    /*if(self.rows[i].amount.includes(',')){
                        amount = self.rows[i].amount.replace(',','');
                    }else{
                        amount = self.rows[i].amount;
                    }  
                    subletPartAmount += parseFloat(amount);*/
                    if(self.rows[i].quantity.includes(',')){
                        self.rows[i].quantity = self.rows[i].quantity.replace(',','');
                    }
                    if(self.rows[i].unit_price.includes(',')){
                        self.rows[i].unit_price = self.rows[i].unit_price.replace(',','');
                    }

                    self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    subletPartAmount += self.rows[i].amount;
                    self.rows[i].amount = self.rows[i].amount.toFixed(2);
                }else if (self.rows[i].type == "charges" && self.rows[i].amount != ""){     
                    if(self.rows[i].amount.includes(',')){
                        amount = self.rows[i].amount.replace(',','');
                    }else{
                        amount = self.rows[i].amount;
                    }  
                    otherCharges += parseFloat(amount);
                // }else if(self.rows[i].type == "ADMIN" || self.rows[i].type == "ENVIR" || self.rows[i].type == "FET" || self.rows[i].type == "FRT" || self.rows[i].type == "RSTOCK"){
                }else if (self.rows[i].amount != "") {
                     amount = self.rows[i].amount;
                   otherCharges += parseFloat(amount);
                }
            }

            var rate = 0 ;
            if (self.customerPriceBookArr.length){
            
                var laborObj = self.arrayColumn(self.customerPriceBookArr,'S');
                if (laborObj != undefined && laborObj.rate_type && laborObj.rate_type == 'L'){
                    rate = laborObj.rate;
                }else{
                    var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'S');
                    if (laborDefObj != undefined && laborDefObj.rate_type == 'L'){
                    rate = laborDefObj.rate;
                    }
                }
            }else{
                var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'S');
                if (laborDefObj != undefined && laborDefObj.rate_type == 'L'){
                rate = laborDefObj.rate;
                }
            }
            var laborAmount = 0;
            self.shop_supplies = totalLaborAmount * rate / 100;


            totalSubletAmount = subletAmount + subletLaborAmount + subletPartAmount;

            totalBeforeTax = totalLaborAmount + totalPartAmount + totalSubletAmount + otherCharges + self.shop_supplies;

            salesTaxAmount = totalPartAmount + subletPartAmount;
            
            salesTax = parseFloat((salesTaxAmount / 100) * salesTaxPercent);

            supplySalesTax = parseFloat(self.shop_supplies) * salesTaxPercent / 100;

            totalTaxes = salesTax + supplySalesTax;

            self.total_labor = parseFloat(totalLaborAmount);

            self.total_parts = parseFloat(totalPartAmount);

            self.total_sublet = parseFloat(totalSubletAmount);

            self.sales_tax = parseFloat(salesTax) + parseFloat(supplySalesTax);

            self.sub_total = parseFloat(totalBeforeTax);

            self.total_tax = parseFloat(totalTaxes);

            self.other_charges = parseFloat(otherCharges);

        },
        calculateTaxSubTotal(){
            var self = this;
            var totalLaborAmount = 0;
            var totalPartAmount = 0;
            for(var i=0;i<self.rows.length;i++)
            {

                /*if (self.rows[i].quantity > 0 || self.rows[i].unit_price > 0 ) {

                    self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    // self.rows[i].amount = self.rows[i].amount.toFixed(2);
                    self.rows[i].total = self.rows[i].amount;
                    self.rows[i].total = self.rows[i].amount + self.rows[i].tax_amount;

                }else{
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    self.rows[i].total = self.rows[i].amount;
                    self.rows[i].total = self.rows[i].amount + self.rows[i].tax_amount;
                }*/
                if(self.rows[i].type == "labor"){
                    self.rows[i].amount=self.rows[i].hours * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalLaborAmount += self.rows[i].amount; 
                }else{
                    self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;                
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    totalPartAmount += self.rows[i].amount;    
                }
            }

            self.total_labor = totalLaborAmount;

            self.total_parts = totalPartAmount;

            self.sub_total = self.total_labor + self.total_parts;
            
            self.sales_tax = parseFloat((self.total_parts / 100) * self.city_sales_tax);
            self.total_tax = self.sales_tax;

            /*self.sub_total="";            
            self.sub_total = self.rows.reduce(function(prev, cur) {
                // return prev + (cur.quantity * cur.unit_price);
                return prev + (cur.amount);
            }, 0);

            self.total_tax="";            
            self.total_tax = self.rows.reduce(function(prev, cur) {
                return prev + (cur.tax_amount);
            }, 0);*/

            // self.total_tax = parseFloat((self.tax / 100) * self.sub_total);

        },
        removeItem: function (event,index) {
            var self = this;
            if(self.rows.length > 1) {

                if (self.rows[index].invoice_item_id == 0) {
                    self.rows.splice(index, 1);
                    self.calculateTotal(event,index);

                }else {   
                    
                    if (confirm('Are you sure that you want to remove this line? ')) {

                        self.loading = true;
                        $.ajax({
                            url: process.env.ROOT_API + "/invoice/wo/item/delete",
                            type: "POST",
                            data: {'invoice_item_id': self.rows[index].invoice_item_id},
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {

                                    setTimeout(function () {
                                        self.loadInvoice();                                            
                                    },50);

                                }
                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'wo-invoice-item-delete');
                            },
                        });
                    }
                                      
                }
            }
            if ( self.rows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        CreateInvoice(flag) {

            var self = this;
            var error = false;
            self.customer_error_msg = "";
            // self.invoice_number_error_msg = "";
            self.invoice_date_error_msg = "";
            self.due_date_error_msg = "";
            self.invoice_type_error_msg = "";
            self.common_error_msg = "";
            self.emails_error_msg ='';
            
            
            
            if ( self.customer_id == null ) {
                self.customer_error_msg = "Customer Required.";
                error = true;
            }

            if ( self.emails == null || self.emails == "" ) {
                self.emails_error_msg = "Emails Required.";
                error = true;
            }

            if (self.emails.includes(',')){
                var emails = self.emails.split(',');

                if (emails.length > 0){
                    for( var i=0;i < emails.length;i++){
                        if (!self.validEmail(emails[i])){
                            self.emails_error_msg = 'Please enter valid email';
                            error = true;
                        }
                    }
                }
            }else{
                if (self.emails != '' && !self.validEmail(self.emails)){
                    self.emails_error_msg = 'Please enter valid email';
                    error = true;
                }
            }

            if (!self.invoice_date || self.invoice_date == null || self.invoice_date == "") {
                self.invoice_date_error_msg = "Invoice Date Required.";
                error = true;
            }

            if (!self.due_date || self.due_date == null || self.due_date == "") {
                self.due_date_error_msg = "Due Date Required.";
                error = true;
            }

            if ( self.invoice_type == null ) {
                self.invoice_type_error_msg = "Invoice Type Required.";
                error = true;
            }

            // if ( self.reason_id == null || self.reason_id == "" ) {
            //     self.reason_error_msg = "Reason Required.";
            //     error = true;
            // }

            if ( (self.invoice_date && self.invoice_date != null && self.invoice_date != "")
                && (self.due_date && self.due_date != null && self.due_date!= "")
                && (Date.parse(self.due_date) < Date.parse(self.invoice_date))) {
                self.due_date_error_msg = "Due Date cannot be earlier than Invoice Date.";
                error = true;
            }

            for (var i = 0; i < self.rows.length; i++) {
            
                self.rows[i].desc_error_msg = "";
                self.rows[i].quantity_error_msg = "";
                self.rows[i].unit_price_error_msg = "";
                self.rows[i].amount_error_msg = "";
                self.rows[i].vmrs_system_part_error_msg = "";
                self.rows[i].hour_error_msg = "";
                self.rows[i].item_type_error_msg = "";
                
                if(  self.rows[i].item_type == null || self.rows[i].item_type.value == "") {
                    self.rows[i].item_type_error_msg = "Type Required.";
                    error = true;                    
                }

                // if ( self.rows[i].vmrs_system_part_number == null || self.rows[i].vmrs_system_part_number == "" ) {
                //     self.rows[i].vmrs_system_part_error_msg = "Part Number Required.";
                //     error = true;
                // }

                if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                    self.rows[i].desc_error_msg = "Description Required.";
                    error = true;
                }

                // if ( self.rows[i].hours == null || String(self.rows[i].hours) == "") {
                //     self.rows[i].hour_error_msg = "Hours Required.";
                //     error = true;
                // }

                // if ( self.rows[i].quantity == null || String(self.rows[i].quantity) == "" ) {
                //     self.rows[i].quantity_error_msg = "Quantity Required.";
                //     error = true;
                // }

                // if ( self.rows[i].unit_price == null || String(self.rows[i].unit_price) == "") {
                //     self.rows[i].unit_price_error_msg = "Unit Price Required.";
                //     error = true;
                // }

                if (self.rows[i].amount == null || String(self.rows[i].amount) == "") {
                    self.rows[i].amount_error_msg = "Amount Required.";
                    error = true;
                }

                // if (String(self.rows[i].hours) != "" && self.rows[i].hours <= 0) {
                //     self.rows[i].hour_error_msg = "Hours Must Be Greater than 0.";
                //     error = true;    
                // }

                // if (String(self.rows[i].quantity) != "" && self.rows[i].quantity <= 0) {
                //     self.rows[i].quantity_error_msg = "Quantity Must Be Greater than 0.";
                //     error = true;    
                // }

                // if (String(self.rows[i].unit_price) != "" && self.rows[i].unit_price <= 0) {
                //     self.rows[i].unit_price_error_msg = "Unit Price Must Be Greater than 0.";
                //     error = true;    
                // }

                if (String(self.rows[i].amount) != "" && self.rows[i].amount == 0) {
                    self.rows[i].amount_error_msg = "Amount cannot be 0.";
                    error = true;    
                }

                if( self.rows[i].item_type != null && self.rows[i].item_type.value != "") {

                    if( self.rows[i].item_type.value == "labor" ) {
                        
                        if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                            self.rows[i].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[i].hours == null || String(self.rows[i].hours) == "") {
                            self.rows[i].hour_error_msg = "Hours Required.";
                            error = true;
                        }

                        if ( self.rows[i].unit_price == null || String(self.rows[i].unit_price) == "") {
                            self.rows[i].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                        }

                        if (String(self.rows[i].hours) != "" && self.rows[i].hours == 0) {
                            self.rows[i].hour_error_msg = "Hours cannot be 0.";
                            error = true;
                        }

                        if (self.rows[i].hours == "-") {
                            self.rows[i].hour_error_msg = "Hours cannot be "-" ";
                            error = true;
                        }

                        if (String(self.rows[i].unit_price) != "" && self.rows[i].unit_price == 0) {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;
                        }
                        

                    }else if( self.rows[i].item_type.value == "part" ) {
                        
                        if ( self.rows[i].vmrs_system_part_number == null || self.rows[i].vmrs_system_part_number == "" ) {
                            self.rows[i].vmrs_system_part_error_msg = "Part Number Required.";
                            error = true;
                        }

                        if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                            self.rows[i].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[i].quantity == null || String(self.rows[i].quantity) == "" ) {
                            self.rows[i].quantity_error_msg = "Quantity Required.";
                            error = true;
                        }

                        if ( self.rows[i].unit_price == null || String(self.rows[i].unit_price) == "") {
                            self.rows[i].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                        }

                        if (String(self.rows[i].quantity) != "" && self.rows[i].quantity == 0) {
                            self.rows[i].quantity_error_msg = "Quantity cannot be 0.";
                            error = true;    
                        }

                        if (String(self.rows[i].unit_price) != "" && self.rows[i].unit_price == 0) {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[i].quantity == "-") {
                            self.rows[i].quantity_error_msg = "Quantity cannot be "-" ";
                            error = true;
                        }
                        if (self.rows[i].unit_price == "-") {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be "-" ";
                            error = true;
                        }

                    }else if( self.rows[i].item_type.value == "sublet_amount" ) {                    
                        
                        if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                            self.rows[i].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if (self.rows[i].amount == null || String(self.rows[i].amount) == "") {
                            self.rows[i].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[i].amount) != "" && self.rows[i].amount == 0) {
                            self.rows[i].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[i].amount == "-") {
                            self.rows[i].amount_error_msg = "Amount Price cannot be "-" ";
                            error = true;
                        }
                        

                    }else if( self.rows[i].item_type.value == "sublet_labor" ) {
                    
                        if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                            self.rows[i].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[i].hours == null || String(self.rows[i].hours) == "") {
                            self.rows[i].hour_error_msg = "Hours Required.";
                            error = true;
                        }

                        if ( self.rows[i].unit_price == null || String(self.rows[i].unit_price) == "") {
                            self.rows[i].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                        }

                        if (String(self.rows[i].hours) != "" && self.rows[i].hours == 0) {
                            self.rows[i].hour_error_msg = "Hours cannot be 0.";
                            error = true;
                        }

                        if (String(self.rows[i].unit_price) != "" && self.rows[i].unit_price == 0) {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                        }

                        if (self.rows[i].amount == null || String(self.rows[i].amount) == "" ) {
                            self.rows[i].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[i].amount) != "" && self.rows[i].amount == 0) {
                            self.rows[i].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[i].hours == "-") {
                            self.rows[i].hour_error_msg = "Hours cannot be "-" ";
                            error = true;
                        }
                        if (self.rows[i].unit_price == "-") {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be "-" ";
                            error = true;
                        }
                        if (self.rows[i].amount == "-") {
                            self.rows[i].amount_error_msg = "Amount Price cannot be "-" ";
                            error = true;
                        }

                    }else if( self.rows[i].item_type.value == "sublet_part" ) {
                        
                        if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                            self.rows[i].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if ( self.rows[i].unit_price == null || String(self.rows[i].unit_price) == "") {
                            self.rows[i].unit_price_error_msg = "Unit Price Required.";
                            error = true;
                        }

                        if (String(self.rows[i].quantity) != "" && self.rows[i].quantity == 0) {
                            self.rows[i].quantity_error_msg = "Quantity cannot be 0.";
                            error = true;    
                        }

                        if (String(self.rows[i].unit_price) != "" && self.rows[i].unit_price == 0) {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be 0.";
                            error = true;    
                        }

                        if (self.rows[i].amount == null || String(self.rows[i].amount) == "") {
                            self.rows[i].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[i].amount) != "" && self.rows[i].amount == 0) {
                            self.rows[i].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[i].quantity == "-") {
                            self.rows[i].quantity_error_msg = "Quantity cannot be "-" ";
                            error = true;
                        }
                        if (self.rows[i].unit_price == "-") {
                            self.rows[i].unit_price_error_msg = "Unit Price cannot be "-" ";
                            error = true;
                        }
                        if (self.rows[i].amount == "-") {
                            self.rows[i].amount_error_msg = "Amount cannot be "-" ";
                            error = true;
                        }
                    // }else if( self.rows[i].item_type.value == "ADMIN" || self.rows[i].item_type.value == "ENVIR"  || self.rows[i].item_type.value == "FET" ||
                    //           self.rows[i].item_type.value == "FRT" || self.rows[i].item_type.value == "RSTOCK" ) {
                    }else{    
                        
                        if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                            self.rows[i].desc_error_msg = "Description Required.";
                            error = true;
                        }

                        if (self.rows[i].amount == null || String(self.rows[i].amount) == "") {
                            self.rows[i].amount_error_msg = "Amount Required.";
                            error = true;
                        }

                        if (String(self.rows[i].amount) != "" && self.rows[i].amount == 0) {
                            self.rows[i].amount_error_msg = "Amount cannot be 0.";
                            error = true;    
                        }
                        if (self.rows[i].amount == "-") {
                            self.rows[i].amount_error_msg = "Amount cannot be "-" ";
                            error = true;
                        }
                    }
                }    
            }

            if (self.rows.length < 1) {
                error = true;
                self.common_error_msg = "No Line Item Found. Invoice cannot be generated."
            }

            if (!error) {
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3])
                {
                    $("#CreateInvoiceBtn").val("Updating ...");
                    $("#CreateInvoiceBtn").prop("disabled", true);
                    $("#cancelInvoiceBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueInvoiceBtn").val("Saving ...");
                        $("#CreateInvoiceBtn").prop("disabled", true);
                        $("#createAndContinueInvoiceBtn").prop("disabled", true);
                        $("#cancelInvoiceBtn").prop("disabled",true);

                    } else{

                        $("#CreateInvoiceBtn").val("Saving ...");
                        $("#CreateInvoiceBtn").prop("disabled", true);
                        $("#createAndContinueInvoiceBtn").prop("disabled", true);
                        $("#cancelInvoiceBtn").prop("disabled",true);
                    }
                }

                var fields = $("#InvoiceForm").serializeArray();

                fields.push({name: "customer_id", value: self.customer_id.value});

                if (self.invoice_type == null) {
                    fields.push({name: "invoice_type", value: ""});
                } else{
                    fields.push({name: "invoice_type", value: self.invoice_type.value});
                }

                // if (self.customer_purchase_order == null) {
                //     fields.push({name: "customer_purchase_order_id", value: ""});
                // } else{
                //     fields.push({name: "customer_purchase_order_id", value: self.customer_purchase_order.value});
                // }

                if (self.term == null || self.term == "") {
                    fields.push({name: "term", value: ""});
                } else{
                    fields.push({name: "term", value: self.term.value});
                }
                fields.push({name: "location_id", value: self.location_id});
                fields.push({name: "vehicle_id", value: self.vehicle_id});

                fields.push({name: "sub_total", value: self.sub_total});
                /*if ( self.tax == "" || self.tax == null) {
                    self.tax = 0;
                    self.total_tax = 0;
                    fields.push({name: "tax_percent", value: self.tax});
                }else{
                    fields.push({name: "tax_percent", value: self.tax});
                }*/
                fields.push({name: "tax_amount", value: self.total_tax});
                fields.push({name: "total", value: self.total});
                
                if (!self.rows[0]) {
                       
                    self.rows = [];
                }

                for (var i = 0; i < self.rows.length; i++) {

                    // if (self.rows[i].tax_id == null || self.rows[i].tax_id == "") {
                    //     self.rows[i].tax_id = "";
                    //     self.rows[i].tax_amount = 0;
                    //     self.rows[i].total = self.rows[i].amount + self.rows[i].tax_amount;
                    // }
                }

                fields.push({name:"reason_id",value: self.reason_id.value});
                fields.push({name:"parent_id",value:  self.$route.query.inv_id});
                
                fields.push({name: "invoiceItems", value: JSON.stringify(self.rows)});
                fields.push({ name: "id", value: segments[4] });

                console.log(fields);
                $.ajax({
                    url: process.env.ROOT_API + "/invoice/wo/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if (segments[3])
                        {
                            $("#CreateInvoiceBtn").val("Update");
                            $("#CreateInvoiceBtn").prop("disabled", false);
                            $("#cancelInvoiceBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueInvoiceBtn").val("Save and Continue");
                                $("#CreateInvoiceBtn").prop("disabled", false);
                                $("#createAndContinueInvoiceBtn").prop("disabled", false);
                                $("#cancelInvoiceBtn").prop("disabled",false);

                            } else{

                                $("#CreateInvoiceBtn").val("Save");
                                $("#CreateInvoiceBtn").prop("disabled", false);
                                $("#createAndContinueInvoiceBtn").prop("disabled", false);
                                $("#cancelInvoiceBtn").prop("disabled",false);

                            }
                        }                        
                        
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {
                                
                                $("#InvoiceForm").trigger("reset");                                
                                self.customer_id = null;
                                self.customer_purchase_order = null;
                                // self.invoice_number = "";
                                self.term = "";
                                self.invoice_type = null;
                                self.emails = '';          
                                self.rows=[];
                                self.rows.push({
                                    invoice_item_id:0,          
                                    description:"",
                                    desc_error_msg:"",           
                                    quantity:"",
                                    quantity_error_msg:"",            
                                    unit_price:"",
                                    unit_price_error_msg:"",            
                                    amount:0,
                                    actual_amount:0,
                                    amount_error_msg:"",
                                    // tax_id:"",
                                    // tax_amount:0,
                                    total:0            
                                });                                
                                
                                
                                self.sub_total = 0;
                                self.sub_total.toFixed(2);

                                // self.tax = 0;
                                self.total_tax = 0;
                                self.total_tax.toFixed(2);

                                self.total = 0;
                                self.showTotalSummary = false;

                            } else{
                                
                                if (self.$route.params.from != undefined && self.$route.params.from == 'woInvList') {
                                    self.$router.push({name: 'WorkOrderSalesInvoiceView',params:{id:data.content.invoiceId,from:'woInvList'}});
                                }else{
                                    self.$router.push("/invoice/wo/view/"+data.content.invoiceId);
                                }
                                // self.$router.push("/invoice/list");
                            }

                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                // for (var i = 0; i < data.content.length; i++) {
                                //     err += data.content[i] + "<br>";
                                // }
                                 err += data.content + "<br>";
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#CreateInvoiceBtn").val("Update");
                            $("#CreateInvoiceBtn").prop("disabled", false);
                            $("#cancelInvoiceBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                $("#createAndContinueInvoiceBtn").val("Save and Continue");
                                $("#CreateInvoiceBtn").prop("disabled", false);
                                $("#createAndContinueInvoiceBtn").prop("disabled", false);
                                $("#cancelInvoiceBtn").prop("disabled",false);

                            } else{

                                $("#CreateInvoiceBtn").val("Save");
                                $("#CreateInvoiceBtn").prop("disabled", false);
                                $("#createAndContinueInvoiceBtn").prop("disabled", false);
                                $("#cancelInvoiceBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,false,'wo-invoice-create');
                    }
                });
            }else{
                self.errorValidationFocus();
            }

        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        isNumberCheck: function(evt) {
            
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            //handle - sign to enter only once
            if (charCode === 45 && evt.target.value.split('-').length > 1) {
                evt.preventDefault();
            }
            if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 45) && (charCode !== 46 || evt.target.value.indexOf('.') != -1) && charCode !== 44 && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onTaxSelect(event,index) {
            var self = this;
            if( self.rows[index].tax_id != null && self.rows[index].tax_id != ""){
                self.rows[index].tax_amount =  parseFloat(( self.rows[index].amount * self.rows[index].tax_id.percentage ) / 100);
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
            }else{
                self.rows[index].tax_amount = 0;
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;      
            }
            self.calculateTaxSubTotal();
        },
        onItemTypeSelect(event,index) {        
            var self = this;
            self.rows[index].desc_error_msg = "";
            self.rows[index].quantity_error_msg = "";
            self.rows[index].unit_price_error_msg = "";
            self.rows[index].amount_error_msg = "";
            self.rows[index].vmrs_system_part_error_msg = "";
            self.rows[index].hour_error_msg = "";
            self.rows[index].item_type_error_msg = "";
            
            // console.log('item type:'+self.rows[index].item_type.value);
            // console.log('item amount:'+self.rows[index].amount);
            console.log( self.rows[index].item_type.value);
            // if(self.rows[index].wo_item_id==null){
                
            //     if( self.rows[index].item_type.value == "labor" ) {
            //         self.rows[index].type='labor';

            //     }else if( self.rows[index].item_type.value == "part" ) {
            //         self.rows[index].type='part';

            //     }else if( self.rows[index].item_type.value == "sublet_labor" ) {
            //         self.rows[index].type='sublet_labor';
            //     }else if( self.rows[index].item_type.value == "sublet_part" ) {
            //         self.rows[index].type='sublet_part';
            //     }
            // }
            //     console.log(self.rows);
            if( self.rows[index].item_type != null ) {

                if( self.rows[index].item_type.value == "labor" ) {
                    
                    self.rows[index].type = "labor";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 0;
                    self.rows[index].is_charge = 0;   
                                 

                }else if( self.rows[index].item_type.value == "part" ) {
                    self.rows[index].type = "part";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 0; 
                    self.rows[index].is_charge = 0;                   

                }else if( self.rows[index].item_type.value == "sublet_amount" ) {
                    self.rows[index].type = "sublet_amount";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 0;                    

                }else if( self.rows[index].item_type.value == "sublet_labor" ) {
                    self.rows[index].type = "sublet_labor";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "1";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 0;                    

                }else if( self.rows[index].item_type.value == "sublet_part" ) {
                    self.rows[index].type = "sublet_part";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "1";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 0;                    
                }else if( self.rows[index].item_type.value == "ADMIN" ) {
                    self.rows[index].type = "ADMIN";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 1;                    
                }else if( self.rows[index].item_type.value == "ENVIR" ) {
                    self.rows[index].type = "ENVIR";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 1;                    
                }else if( self.rows[index].item_type.value == "FET" ) {
                    self.rows[index].type = "FET";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 1;                    
                }else if( self.rows[index].item_type.value == "FRT" ) {
                    self.rows[index].type = "FRT";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 1;                    
                }else if( self.rows[index].item_type.value == "RSTOCK" ) {
                    self.rows[index].type = "RSTOCK";
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 1;                    
                }else {
                    self.rows[index].type = self.rows[index].item_type.value;
                    self.rows[index].vmrs_system_part_number = "";
                    self.rows[index].description = "";
                    self.rows[index].quantity = "";
                    self.rows[index].hours = "";
                    self.rows[index].unit_price = "";
                    self.rows[index].amount = self.rows[index].item_type.rate;
                    self.rows[index].is_sublet = 1;
                    self.rows[index].is_charge = 1;                    
                }     
                self.calculateTotal(event,index);
            }            
        },
        loadInvoice() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            var invId = '';
            if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
                invId = self.$route.query.inv_id;
            }else{
                invId = segments[4];
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/wo/" + invId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    
                    if (data.status == "success") {
                        self.customer_id = {
                            value: data.content.customer_id,
                            text: self.titleCase(data.content.cusCode + " | " + data.content.cusName)
                        };
                        self.invoice_number = data.content.invoice_number;
                        // self.invoice_date = data.content.invoice_date;
                        self.emails = data.content.customer_emails;
                        // self.due_date = data.content.due_date;
                        if (self.isCredit == true){
                            self.invoice_date = self.getTodayDate();
                            if (data.content.termqty != undefined && data.content.term_period !=  undefined && data.content.term_period != null && data.content.term_period != ''){
                                // self.due_date = moment(self.invoice_date).add(data.content.termqty + ', "'+data.content.term_period.toLowerCase()+'"').format('MM/DD/YYYY');
                                self.due_date = moment(self.invoice_date, "MM/DD/YYYY").add(data.content.termqty, data.content.term_period.toLowerCase());
                            }
                        }else{
                            self.invoice_date = data.content.invoice_date;
                            self.due_date = data.content.due_date;
                        }
                        if (data.content.invoice_type_id != null) {
                            self.invoice_type = {
                                value:data.content.invoice_type_id,
                                text:self.formatString(data.content.invTypeName) + " (" + data.content.invTypeCode + ")"
                            }
                        }else{
                            self.invoice_type = null;
                        }
                        
                        if ( data.content.customer_po_id != null) {
                            self.customer_purchase_order = {
                                value:data.content.customer_po_id,
                                text:self.titleCase(data.content.cpoNumber)
                            }
                        }else{
                            self.customer_purchase_order = null;
                        }

                        if ( data.content.term_id != null) {
                            self.term = {
                                value:data.content.term_id,
                                text:self.titleCase(data.content.termName) + " (" + self.titleCase(data.content.termCode) + ")"
                            }
                        }else{
                            self.term = null;
                        }

                        // self.loadInvoiceItems();
                        if ( data.content.vUnitNo != null) {
                            self.unit = data.content.vUnitNo;
                            self.vinNumber = data.content.vin;
                        }else{
                            self.unit = data.content.customer_unit_no;
                            self.vinNumber = data.content.customer_vin_number;
                        }

                        self.meter = data.content.miles;
                        self.facility = self.titleCase(data.content.lCode) + " | " + self.titleCase(data.content.lName);
                        self.dateIn = data.content.open_date;
                        self.dateOut = data.content.wo_updated_at_date;                   

                        self.total_labor = self.reverseFormat(data.content.total_labor_amount);
                        self.total_parts = self.reverseFormat(data.content.total_part_amount);
                        self.total_sublet = self.reverseFormat(data.content.total_sublet);
                        // self.total_environmental = data.content.total_environmental;
                        self.other_charges = self.reverseFormat(data.content.other_charges);
                        self.shop_supplies = self.reverseFormat(data.content.shop_supplies);
                        self.sub_total = self.reverseFormat(data.content.total_before_tax);
                        self.sales_tax = self.reverseFormat(data.content.sales_tax);
                        self.total_tax = self.reverseFormat(data.content.total_taxes);
                        self.total = self.reverseFormat(data.content.total);
                        self.location_id = data.content.location_id;
                        self.city_sales_tax=data.content.city_sales_tax;
                        self.rows = [];
                        setTimeout(function(){
                            self.customerCall = true;
                            self.termCall = true;
                            self.invDateCall = true;
                        },3000);
                        if (data.content.invoice_items.length >=1) {

                            for (var i = 0; i < data.content.invoice_items.length; i++) {
                                self.rows.push({
                                    wo_labor_id:data.content.invoice_items[i].wo_labor_id,
                                    wo_component_id:data.content.invoice_items[i].wo_component_id,
                                    wo_item_id:data.content.invoice_items[i].wo_item_id,
                                    work_order_id:data.content.invoice_items[i].work_order_id,
                                    // service_task_id:items[i].service_task_id,
                                    // service_task_name:items[i].service_task_name,
                                    // service_task_code:items[i].service_task_code,
                                    component_id:data.content.invoice_items[i].component_id,
                                    // component_name:items[i].component_name,
                                    // component_code:items[i].component_code,
                                    hours:(data.content.invoice_items[i].hours != "" && data.content.invoice_items[i].hours != "-")?self.reverseFormat(self.hourFormat(data.content.invoice_items[i].hours)):"",
                                    quantity:(data.content.invoice_items[i].quantity != "" && data.content.invoice_items[i].quantity != "-")?self.reverseFormat(self.amountFormat(data.content.invoice_items[i].quantity)):"",
                                    unit_price:(data.content.invoice_items[i].unit_price != "" && data.content.invoice_items[i].unit_price != "-")?self.amountFormat(data.content.invoice_items[i].unit_price):"",
                                    amount:self.reverseFormat(self.amountFormat(data.content.invoice_items[i].amount)),
                                    actual_amount:data.content.invoice_items[i].amount,
                                    description:data.content.invoice_items[i].description,
                                    vmrs_system_part_number:data.content.invoice_items[i].vmrs_system_part_number,
                                    type:data.content.invoice_items[i].type,
                                    invoice_item_id:(self.$route.query.from != undefined && self.$route.query.from == 'credit') ? 0 : data.content.invoice_items[i].invoice_item_id,
                                    wo_invoice_mapper_id:(self.$route.query.from != undefined && self.$route.query.from == 'credit') ? 0 : data.content.invoice_items[i].wo_invoice_mapper_id,
                                    is_sublet:data.content.invoice_items[i].is_sublet,
                                    item_type:{
                                        text:data.content.invoice_items[i].item_type.text,
                                        value:data.content.invoice_items[i].item_type.value
                                    },
                                    vmrs_system_part_error_msg:"",
                                    desc_error_msg:"",
                                    hour_error_msg:"",
                                    quantity_error_msg:"",            
                                    unit_price_error_msg:"",            
                                    amount_error_msg:"",
                                    item_type_error_msg:"",
                                    is_charge:data.content.invoice_items[i].is_charge
                                    // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                    //     value: data.content[i].tax_id,
                                    //     text: data.content[i].tax_name,
                                    //     percentage:data.content[i].tax_percentage,
                                    // } : "",
                                    // tax_amount:data.content[i].tax_amount,
                                    // total:0      
                                });
                                self.work_order_id = data.content.invoice_items[i].work_order_id;
                            }

                        }else{

                        }
                        self.disableField = true;
                        if ( self.rows.length > 1) {
                            self.showTotalSummary = true;
                        }else{
                            self.showTotalSummary = false;
                        }
                    } 
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'wo-invoice-details');
                }
            });
        },
        loadInvoiceItems() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/item/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.rows = [];
                        if (data.content.length >= 1) {
                            for (var i = 0; i < data.content.length; i++) {
                                self.rows.push({
                                    invoice_item_id:data.content[i].invoice_item_id,          
                                    description:data.content[i].description,
                                    desc_error_msg:"",           
                                    quantity:data.content[i].quantity,
                                    quantity_error_msg:"",            
                                    unit_price:data.content[i].unit_price,
                                    unit_price_error_msg:"",            
                                    amount:data.content[i].amount,
                                    actual_amount:data.content[i].amount,
                                    amount_error_msg:"",
                                    // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                    //     value: data.content[i].tax_id,
                                    //     text: data.content[i].tax_name,
                                    //     percentage:data.content[i].tax_percentage,
                                    // } : "",
                                    // tax_amount:data.content[i].tax_amount,
                                    total:data.content[i].total           
                                });    
                            }

                        }else{

                            self.rows.push({
                                invoice_item_id:0,          
                                description:"",
                                desc_error_msg:"",           
                                quantity:"",
                                quantity_error_msg:"",            
                                unit_price:"",
                                unit_price_error_msg:"",            
                                amount:0,
                                actual_amount:0,
                                amount_error_msg:"",
                                // tax_id:"",
                                // tax_amount:0,
                                total:0            
                            });    
                        }
                        if ( self.rows.length > 1) {
                            self.showTotalSummary = true;
                        }else{
                            self.showTotalSummary = false;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'wo-invoice-items');
                }
            });
        },
        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        formatString(data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        //on customer select prefill term value if term already defined for customer
        termSelect() {
            var self = this;
            if (self.customer_id != null) {
                if (self.customer_id.term_value != undefined) {
                    if (self.customer_id.term_value != null) {
                        self.term = {
                            text: self.customer_id.term,
                            value:self.customer_id.term_value,
                            term:self.customer_id.term_term,
                            period:self.customer_id.term_period,
                            code:self.customer_id.term_code
                        }
                        if (self.$route.params.id != undefined && self.$route.params.id > 0) {
                            self.calculateDueDate();
                        }
                    }
                }
                if (self.customer_id.email != undefined) {
                    if (self.customer_id.email != null && self.customer_id.email != "") {
                        self.emails = self.customer_id.email;
                    }else{
                        self.emails = "";
                    }
                }
            }
        },
        loadWorkOrderDataForInvoice() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/wo",
                type: "POST",
                headers: this.ajxHeaders,
                data: {work_order_id:self.work_order_id},
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.customer_id = {
                            value: data.content.work_order_data.customer_id,
                            text: self.titleCase(data.content.work_order_data.cusCode + " | " + data.content.work_order_data.cusName)
                        };
                        self.emails = data.content.work_order_data.cusEmail;

                        if ( data.content.work_order_data.termId != null) {
                            self.term = {
                                value:data.content.work_order_data.termId,
                                text:self.titleCase(data.content.work_order_data.termName) + " (" + self.titleCase(data.content.work_order_data.termCode) + ")",
                                term:data.content.work_order_data.termPeriod,
                                period:data.content.work_order_data.termType,
                                code:data.content.work_order_data.termCode.toLowerCase()
                            }
                        }else{
                            self.term = null;
                        }

                        // if ( data.content.work_order_data.customer_purchase_order_id != null) {
                        //     self.customer_purchase_order = {
                        //         value:data.content.work_order_data.customer_purchase_order_id,
                        //         text:self.titleCase(data.content.work_order_data.cpoNumber)
                        //     }
                        // }else{
                        //     self.customer_purchase_order = null;
                        // }
                        self.customer_purchase_order = data.content.work_order_data.cpoNumber;

                        if ( data.content.work_order_data.vehicle_id != null) {
                            self.vehicle_id = data.content.work_order_data.vehicle_id;
                            self.unit = data.content.work_order_data.vUnitNo;
                            self.vinNumber = data.content.work_order_data.vinNumber;
                        }else{
                            self.unit = data.content.work_order_data.customer_unit_no;
                            self.vinNumber = data.content.work_order_data.customer_vin_number;     
                        }

                        self.invoice_date = data.content.work_order_data.invoiceDate;
                        if (data.content.work_order_data.dueDate != "") {
                            self.due_date = data.content.work_order_data.dueDate;
                        }
                        self.meter = data.content.work_order_data.miles;
                        self.location_id = data.content.work_order_data.location_id;
                        self.facility = self.titleCase(data.content.work_order_data.lCode) + " | " + self.titleCase(data.content.work_order_data.lName);
                        self.dateIn = data.content.work_order_data.open_date;
                        self.dateOut = data.content.work_order_data.wo_updated_at_date;

                        self.total_labor = data.content.work_order_data.total_labor_amount;
                        self.total_parts = data.content.work_order_data.total_part_amount;
                        self.total_sublet = data.content.work_order_data.total_sublet;
                        // self.total_environmental = data.content.work_order_data.total_environmental;
                        self.other_charges = data.content.work_order_data.other_charges;
                        self.shop_supplies = data.content.work_order_data.shop_supplies;
                        self.sub_total = data.content.work_order_data.total_before_tax;
                        self.sales_tax = data.content.work_order_data.sales_tax;
                        self.total_tax = data.content.work_order_data.total_taxes;
                        self.total = data.content.work_order_data.total;
                        self.city_sales_tax=data.content.work_order_data.city_sales_tax;
                        if ( data.content.work_order_data.invoice_type_id != null) {
                            self.invoice_type = {
                                value:data.content.work_order_data.invoice_type_id,
                                text:data.content.work_order_data.invoiceType
                            }
                        }else{
                            self.invoice_type = null;
                        }

                        self.rows = [];
                        if (data.content.invoice_items.items.length >= 1) {
                            var items = data.content.invoice_items.items;
                            for (var i = 0; i < items.length; i++) {
                                //part
                                if ( items[i] != undefined && items[i].part != undefined ) {
                                    for (var k = 0; k < items[i].part.length; k++) {

                                        self.rows.push({
                                            wo_labor_id:items[i].part[k].wo_labor_id,
                                            wo_component_id:items[i].part[k].wo_component_id,
                                            wo_item_id:items[i].part[k].wo_item_id,
                                            work_order_id:items[i].part[k].work_order_id,
                                            service_task_id:items[i].part[k].service_task_id,
                                            service_task_name:items[i].part[k].service_task_name,
                                            service_task_code:items[i].part[k].service_task_code,
                                            component_id:items[i].part[k].component_id,
                                            component_name:items[i].part[k].component_name,
                                            component_code:items[i].part[k].component_code,
                                            hours:items[i].part[k].hours,
                                            quantity:self.amountFormat(items[i].part[k].quantity),
                                            unit_price:self.amountFormat(items[i].part[k].unit_price),
                                            amount:self.amountFormat(items[i].part[k].amount),
                                            actual_amount:items[i].part[k].amount,
                                            description:items[i].part[k].description,
                                            vmrs_system_part_number:items[i].part[k].vmrs_system_part_number,
                                            type:items[i].part[k].type,
                                            invoice_item_id:items[i].part[k].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].part[k].wo_invoice_mapper_id,
                                            is_sublet:items[i].part[k].is_sublet,
                                            // item_type:{
                                            //     text:"Part",
                                            //     value:items[i].part[k].type
                                            // },
                                            item_type:items[i].part[k].charge_type,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].part[k].is_charge,
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });
                                    }
                                }
                                //labor
                                if ( items[i] != undefined && items[i].labor != undefined){
                                    for (var j = 0; j < items[i].labor.length; j++) {

                                        self.rows.push({
                                            wo_labor_id:items[i].labor[j].wo_labor_id,
                                            wo_component_id:items[i].labor[j].wo_component_id,
                                            wo_item_id:items[i].labor[j].wo_item_id,
                                            work_order_id:items[i].labor[j].work_order_id,
                                            service_task_id:items[i].labor[j].service_task_id,
                                            service_task_name:items[i].labor[j].service_task_name,
                                            service_task_code:items[i].labor[j].service_task_code,
                                            component_id:items[i].labor[j].component_id,
                                            component_name:items[i].labor[j].component_name,
                                            component_code:items[i].labor[j].component_code,
                                            hours:self.hourFormat(items[i].labor[j].hours),
                                            quantity:items[i].labor[j].quantity,
                                            unit_price:self.amountFormat(items[i].labor[j].unit_price),
                                            amount:self.amountFormat(items[i].labor[j].amount),
                                            actual_amount:items[i].labor[j].amount,
                                            description:items[i].labor[j].description,
                                            vmrs_system_part_number:items[i].labor[j].vmrs_system_part_number,
                                            type:items[i].labor[j].type,
                                            invoice_item_id:items[i].labor[j].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].labor[j].wo_invoice_mapper_id,
                                            is_sublet:items[i].labor[j].is_sublet,
                                            // item_type:{
                                            //     text:"Labor",
                                            //     value:items[i].labor[j].type
                                            // },
                                            item_type:items[i].labor[j].charge_type,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].labor[j].is_charge,    
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });

                                    }

                                }
                                //Sublet Labor Items
                                if ( items[i] != undefined && items[i].sublet_labor_item != undefined){
                                    for (var j = 0; j < items[i].sublet_labor_item.length; j++) {
                                        self.rows.push({
                                            wo_labor_id:items[i].sublet_labor_item[j].wo_labor_id,
                                            wo_component_id:items[i].sublet_labor_item[j].wo_component_id,
                                            wo_item_id:items[i].sublet_labor_item[j].wo_item_id,
                                            work_order_id:items[i].sublet_labor_item[j].work_order_id,
                                            service_task_id:items[i].sublet_labor_item[j].service_task_id,
                                            service_task_name:items[i].sublet_labor_item[j].service_task_name,
                                            service_task_code:items[i].sublet_labor_item[j].service_task_code,
                                            component_id:items[i].sublet_labor_item[j].component_id,
                                            component_name:items[i].sublet_labor_item[j].component_name,
                                            component_code:items[i].sublet_labor_item[j].component_code,
                                            hours:self.hourFormat(items[i].sublet_labor_item[j].hours),
                                            quantity:items[i].sublet_labor_item[j].quantity,
                                            unit_price:self.amountFormat(items[i].sublet_labor_item[j].unit_price),
                                            amount:self.amountFormat(items[i].sublet_labor_item[j].amount),
                                            actual_amount:items[i].sublet_labor_item[j].amount,
                                            description:items[i].sublet_labor_item[j].description,
                                            vmrs_system_part_number:items[i].sublet_labor_item[j].vmrs_system_part_number,
                                            type:items[i].sublet_labor_item[j].sublet_type_labor,
                                            invoice_item_id:items[i].sublet_labor_item[j].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].sublet_labor_item[j].wo_invoice_mapper_id,
                                            is_sublet:items[i].sublet_labor_item[j].is_sublet,
                                            // item_type:{
                                            //     text:"Labor",
                                            //     value:items[i].labor[j].type
                                            // },
                                            item_type:items[i].sublet_labor_item[j].sublet_charge_type_labor,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].sublet_labor_item[j].is_charge,    
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });
                                    }
                                }
                                //Sublet Part Items
                                if ( items[i] != undefined && items[i].sublet_part_item != undefined){
                                    for (var k = 0; k < items[i].sublet_part_item.length; k++) {
                                        self.rows.push({
                                            wo_labor_id:items[i].sublet_part_item[k].wo_labor_id,
                                            wo_component_id:items[i].sublet_part_item[k].wo_component_id,
                                            wo_item_id:items[i].sublet_part_item[k].wo_item_id,
                                            work_order_id:items[i].sublet_part_item[k].work_order_id,
                                            service_task_id:items[i].sublet_part_item[k].service_task_id,
                                            service_task_name:items[i].sublet_part_item[k].service_task_name,
                                            service_task_code:items[i].sublet_part_item[k].service_task_code,
                                            component_id:items[i].sublet_part_item[k].component_id,
                                            component_name:items[i].sublet_part_item[k].component_name,
                                            component_code:items[i].sublet_part_item[k].component_code,
                                            hours:items[i].sublet_part_item[k].hours,
                                            quantity:self.amountFormat(items[i].sublet_part_item[k].quantity),
                                            unit_price:self.amountFormat(items[i].sublet_part_item[k].unit_price),
                                            amount:self.amountFormat(items[i].sublet_part_item[k].amount),
                                            actual_amount:items[i].sublet_part_item[k].amount,
                                            description:items[i].sublet_part_item[k].description,
                                            vmrs_system_part_number:items[i].sublet_part_item[k].vmrs_system_part_number,
                                            type:items[i].sublet_part_item[k].sublet_type_part,
                                            invoice_item_id:items[i].sublet_part_item[k].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].sublet_part_item[k].wo_invoice_mapper_id,
                                            is_sublet:items[i].sublet_part_item[k].is_sublet,
                                            item_type:items[i].sublet_part_item[k].sublet_charge_type_part,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].sublet_part_item[k].is_charge,
                                        });
                                    }
                                }
                                //sublet amount
                                if ( items[i] != undefined && items[i].sublet_amount != undefined){
                                    self.rows.push({
                                            wo_labor_id:items[i].wo_labor_id,
                                            wo_component_id:items[i].wo_component_id,
                                            wo_item_id:items[i].wo_item_id,
                                            work_order_id:items[i].work_order_id,
                                            service_task_id:items[i].service_task_id,
                                            service_task_name:items[i].service_task_name,
                                            service_task_code:items[i].service_task_code,
                                            component_id:items[i].component_id,
                                            component_name:items[i].component_name,
                                            component_code:items[i].component_code,
                                            hours:items[i].hours,
                                            quantity:items[i].quantity,
                                            unit_price:items[i].unit_price,
                                            amount:self.amountFormat(items[i].sublet_amount),
                                            actual_amount:items[i].sublet_amount,
                                            description:items[i].sublet_description,
                                            vmrs_system_part_number:items[i].vmrs_system_part_number,
                                            type:items[i].sublet_type,
                                            invoice_item_id:items[i].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].wo_invoice_mapper_id,
                                            is_sublet:items[i].is_sublet,
                                            // item_type:{
                                            //     text:"",
                                            //     value:""
                                            // },
                                            item_type:items[i].sublet_amount_charge_type,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].is_charge,
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });

                                }

                                if ( items[i] != undefined && items[i].sublet_labor != undefined){
                                    self.rows.push({
                                            wo_labor_id:items[i].wo_labor_id,
                                            wo_component_id:items[i].wo_component_id,
                                            wo_item_id:items[i].wo_item_id,
                                            work_order_id:items[i].work_order_id,
                                            service_task_id:items[i].service_task_id,
                                            service_task_name:items[i].service_task_name,
                                            service_task_code:items[i].service_task_code,
                                            component_id:items[i].component_id,
                                            component_name:items[i].component_name,
                                            component_code:items[i].component_code,
                                            hours:items[i].hours,
                                            quantity:items[i].quantity,
                                            unit_price:items[i].unit_price,
                                            amount:self.amountFormat(items[i].sublet_labor_amount),
                                            actual_amount:items[i].sublet_labor_amount,
                                            description:items[i].sublet_labor_description,
                                            vmrs_system_part_number:items[i].vmrs_system_part_number,
                                            type:items[i].sublet_type_labor,
                                            invoice_item_id:items[i].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].wo_invoice_mapper_id,
                                            is_sublet:items[i].is_sublet,
                                            // item_type:{
                                            //     text:"Sublet Labor",
                                            //     value:items[i].sublet_type_labor
                                            // },
                                            item_type:items[i].sublet_charge_type_labor,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].is_charge,        
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });

                                }

                                if ( items[i] != undefined && items[i].sublet_part != undefined){
                                    self.rows.push({
                                            wo_labor_id:items[i].wo_labor_id,
                                            wo_component_id:items[i].wo_component_id,
                                            wo_item_id:items[i].wo_item_id,
                                            work_order_id:items[i].work_order_id,
                                            service_task_id:items[i].service_task_id,
                                            service_task_name:items[i].service_task_name,
                                            service_task_code:items[i].service_task_code,
                                            component_id:items[i].component_id,
                                            component_name:items[i].component_name,
                                            component_code:items[i].component_code,
                                            hours:items[i].hours,
                                            quantity:items[i].quantity,
                                            unit_price:items[i].unit_price,
                                            amount:self.amountFormat(items[i].sublet_part_amount),
                                            actual_amount:items[i].sublet_part_amount,
                                            description:items[i].sublet_part_description,
                                            vmrs_system_part_number:items[i].vmrs_system_part_number,
                                            type:items[i].sublet_type_part,
                                            invoice_item_id:items[i].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].wo_invoice_mapper_id,
                                            is_sublet:items[i].is_sublet,
                                            // item_type:{
                                            //     text:"Sublet Part",
                                            //     value:items[i].sublet_type_part
                                            // },
                                            item_type:items[i].sublet_charge_type_part,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].is_charge,
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });

                                }

                                if ( items[i] != undefined && items[i].type == 'charges'){
                                    self.rows.push({
                                            wo_labor_id:items[i].wo_labor_id,
                                            wo_component_id:items[i].wo_component_id,
                                            wo_item_id:items[i].wo_item_id,
                                            work_order_id:items[i].work_order_id,
                                            service_task_id:items[i].service_task_id,
                                            service_task_name:items[i].service_task_name,
                                            service_task_code:items[i].service_task_code,
                                            component_id:items[i].component_id,
                                            component_name:items[i].component_name,
                                            component_code:items[i].component_code,
                                            hours:items[i].hours,
                                            quantity:items[i].quantity,
                                            unit_price:items[i].unit_price,
                                            amount:self.amountFormat(items[i].amount),
                                            actual_amount:items[i].amount,
                                            description:items[i].description,
                                            vmrs_system_part_number:items[i].vmrs_system_part_number,
                                            type:items[i].charge_type_name,
                                            invoice_item_id:items[i].invoice_item_id,
                                            wo_invoice_mapper_id:items[i].wo_invoice_mapper_id,
                                            is_sublet:items[i].is_sublet,
                                            // item_type:{
                                            //     text:"",
                                            //     value:""
                                            // },
                                            item_type:items[i].charge_type,
                                            vmrs_system_part_error_msg:"",
                                            desc_error_msg:"",
                                            hour_error_msg:"",
                                            quantity_error_msg:"",            
                                            unit_price_error_msg:"",            
                                            amount_error_msg:"",
                                            item_type_error_msg:"",
                                            is_charge:items[i].is_charge,
                                            // tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            //     value: data.content[i].tax_id,
                                            //     text: data.content[i].tax_name,
                                            //     percentage:data.content[i].tax_percentage,
                                            // } : "",
                                            // tax_amount:data.content[i].tax_amount,
                                            // total:0      
                                        });

                                }
                            }
                          
                        }else{

                        }
                        self.disableField = true;
                        if ( self.rows.length > 1) {
                            self.showTotalSummary = true;
                        }else{
                            self.showTotalSummary = false;
                        }
                    }else{

                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'workorder-invoice-data');
                }
            });
          
        },
        amountFormat(amount) {
            const formatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            });
            
            return formatter.format(amount);
        },

        hourFormat(hour) {
            const formatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            });
            
            return formatter.format(hour);
        },
        onTermChange(e) {
            var self = this;
            if (self.term != null) {
                if (self.term.value != null) {
                    if (self.$route.params.id > 0 && !self.termCall) {
                        return;
                    }else{
                        self.calculateDueDate();
                    }
                }
            }
        },
        onInvDateChange(e) {
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.invDateCall) {
                return;
            }else{
                self.calculateDueDate();
            }
        },
        reverseFormat:function(amt){
            var self = this;

            if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
                if (amt > 0){
                    return -amt;
                }else{
                    return amt;
                }
            }else{
                return amt;
            }
        },
        calculateDueDate(){
            var self = this;
            if (self.invoice_date != null && self.invoice_date != "") {
                var isDueTerm = 0;
                if (self.term != null) {
                    if (self.term.value != null) {
                        if (self.term.code != undefined) {
                            if (self.term.code == "due") {
                                isDueTerm = 1;
                                self.due_date = self.invoice_date;
                            }
                        }
                        if (isDueTerm == 0) {
                            if (self.term.term != undefined) {
                                if (self.term.term != null) {
                                    if (self.term.period != null) {
                                        var date = '';
                                        if (self.term.period == "days") {
                                            date = moment(self.invoice_date, "MM/DD/YYYY").add(self.term.term,'days') //replace 2 with number of days you want to add
                                        }else if (self.term.period == "month") {
                                            date = moment(self.invoice_date, "MM/DD/YYYY").add(self.term.term,'month') //replace 2 with number of days you want to add
                                        }
                                        self.due_date = date;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    
};
</script>




// WEBPACK FOOTER //
// src/components/invoice/WorkOrderInvoiceCreate.vue